<template>
  <div class="capital-distribution-wrapper">
    <CapitalDistribution :data="distributionData" :divisorUnit="divisorUnit" :market="market" />
    <CapitalStatistical :data="distributionData" :divisorUnit="divisorUnit" />
    <CapitalHolding :getUnit="getUnit" />
  </div>
</template>

<script>
import CapitalDistribution from './CapitalDistribution.vue'
import CapitalStatistical from './CapitalStatistical.vue'
import CapitalHolding from './CapitalHolding.vue'
import { getWsJpAddress } from '@/utils/api'
import WebSocketClass from '@/utils/WebSocket/WebSocketClass'
import { jpDecoder } from '@/utils/WebSocket/protobuf/protocolbuf'

export default {
  name: 'CapitalFlow',
  components: { CapitalDistribution, CapitalStatistical, CapitalHolding },
  data() {
    return {
      distributionData: {},
      ws: null
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    timeMode() {
      // 有效值为 '0': 盘中延时 '1': 盘中实时，
      return this.$route.query.timeMode
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    divisorUnit() {
      const {
        capitalInLarge,
        capitalInBig,
        capitalInMid,
        capitalInSmall,
        capitalInTotal,
        capitalOutLarge,
        capitalOutBig,
        capitalOutMid,
        capitalOutSmall,
        capitalOutTotal
      } = this.distributionData
      return this.getUnit([
        capitalInLarge,
        capitalInBig,
        capitalInMid,
        capitalInSmall,
        capitalInTotal,
        capitalOutLarge,
        capitalOutBig,
        capitalOutMid,
        capitalOutSmall,
        capitalOutTotal
      ])
    }
  },
  created() {
    this.getCapitalDistribution()

    // 只有日股实时行情下需要订阅推送
    if (this.market === 'jp' && this.timeMode === '0') {
      this.ws = new WebSocketClass(getWsJpAddress(), jpDecoder)

      this.ws.subscribe({ symbol: this.symbol, command: 40, timeMode: this.timeMode }, (raw) => {
        this.distributionData = raw
      })
    }
  },

  destroyed() {
    if (this.ws) {
      this.ws.unsubscribe({ symbol: this.symbol, command: 41, timeMode: this.timeMode })
    }
  },

  methods: {
    async getCapitalDistribution() {
      const res = await this.$post(
        this.$api.rm[this.market] + '/capital/distribution',
        { symbol: this.symbol },
        {
          headers: {
            'Org-Data-Enable': 'false'
          }
        }
      )
      this.distributionData = res.data ?? {}
    },
    getUnit(data) {
      // 默认单位：万元。若所有数值（特大、大单、中单...）都大于亿需要切换单位为亿元
      // const mapCurrency = {
      //   hk: '港币',
      //   hs: '元',
      //   us: '美元'
      // }
      const mapCurrency = {
        // 产品要求
        hk: '元',
        hs: '元',
        us: '元',
        jp: '元'
      }
      const currency = mapCurrency[this.market]
      const reference = 100000000
      const isMoreThan = data.every((item) => item >= reference)
      if (isMoreThan) {
        return [reference, '亿' + currency]
      } else {
        return [10000, '万' + currency]
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
